/**
 * @param {string | nodeList | HTMLElement} nodes
 * @param {string} className
 * @returns
 */
export const onToggle = (nodes, className) => {
  if (nodes === null || nodes.length === 0) return null

  if (nodes instanceof HTMLElement) {
    nodes.classList.toggle(className)
  } else {
    nodes.forEach((node) => {
      node.classList.toggle(className)
    })
  }
}

export const onAdd = (nodes, className) => {
  if (nodes === null || nodes.length === 0) return null

  if (nodes instanceof HTMLElement) {
    nodes.classList.add(className)
  } else {
    nodes.forEach((node) => {
      node.classList.add(className)
    })
  }
}

export const onRemove = (nodes, className) => {
  if (nodes === null || nodes.length === 0) return null

  if (nodes instanceof HTMLElement) {
    nodes.classList.remove(className)
  } else {
    nodes.forEach((node) => {
      node.classList.remove(className)
    })
  }
}
